import DelegationDetailsRequest from "../../../api/raily/delegation/details/delegation-details.request";
import DelegationDetailsParams from "./delegation-details-params";

const create = (params: DelegationDetailsParams): DelegationDetailsRequest => {
  return {
    delegationUuid: params.delegationUuid,
  };
};

const delegationDetailsParamsFactory = {
  create,
};

export default delegationDetailsParamsFactory;
